export default {
  computed: {
    messageTypeOptions() {
      return [
        { id: 'info', text: this.$gettext('Informativní sdělení') },
        { id: 'maintenance_info', text: this.$gettext('Servisní informace') },
        { id: 'new_service', text: this.$gettext('Nová služba') },
        { id: 'fault', text: this.$gettext('Porucha') },
        { id: 'maintenance', text: this.$gettext('Servis') },
        { id: 'billing', text: this.$gettext('Platby') },
      ]
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/views/messages/mixins/types.js